class GlossarySidebar extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
        const glossaryTitle = this.querySelector(".article__content-sidebar-footer");
        glossaryTitle?.addEventListener("click", this.onGlossaryTitleClick.bind(this))
    }

    onGlossaryTitleClick(event: Event) {
        const sideBar = this.querySelector(".article__content-sidebar");
        sideBar?.classList.toggle("open");
    }
}



customElements.define("glossary-bar", GlossarySidebar);

